import { IMarket } from 'types/market';
import { IFormValues } from '../types';

export type DealMapSource =
    | { type: 'coordinates'; lat: number; lng: number }
    | { type: 'address'; query: string }
    | { type: 'market'; lat: number; lng: number }
    | { type: 'default' };

export const isValidCoordinates = (lat: number, lng: number): boolean => (
    lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180
);

const hasValidFormCoordinates = (values: IFormValues): boolean => {
    const lat = Number(values.latitude);
    const lng = Number(values.longitude);
    return Number.isFinite(lat) && Number.isFinite(lng) && isValidCoordinates(lat, lng);
};

export const buildAddressQuery = (values: IFormValues): string => (
    [values.address, values.city, values.county, values.state, values.zipCode]
        .filter(Boolean)
        .join(', ')
);

export const getDealMapSource = (values: IFormValues, selectedMarket?: IMarket): DealMapSource => {
    if (values.coordinatesSwitch && hasValidFormCoordinates(values)) {
        return { type: 'coordinates', lat: Number(values.latitude), lng: Number(values.longitude) };
    }

    if (!values.coordinatesSwitch) {
        const query = buildAddressQuery(values);
        if (query) return { type: 'address', query };
    }

    if (selectedMarket?.latitude != null && selectedMarket?.longitude != null) {
        return { type: 'market', lat: selectedMarket.latitude, lng: selectedMarket.longitude };
    }

    return { type: 'default' };
};
